import React from 'react';
import { JdsTag } from '../../../components/jds/JdsTag';
import { CouponScopeLabels } from '../../../api/payments/coupons/domain/labels';
import { formatCycleRange, formatRuleValue } from '../../Coupons/v2/utils';

// planName/addonName já vêm prontos em cada rule (ver payload do cupom);
// evita repetir o fetch de PlansAPI/AddonsAPI que o CouponDiscountsTable faz.
export function CouponRulesSummary({ coupon }) {
  const rules = coupon?.rules ?? [];
  if (!rules.length) return null;

  return (
    <div className="d-flex flex-column mt-2" style={{ gap: '4px' }}>
      {rules.map((rule) => (
        <div
          key={rule.id}
          className="d-flex align-items-center flex-wrap"
          style={{ gap: '6px' }}
        >
          <JdsTag
            color="brand"
            label={CouponScopeLabels[rule.scope] ?? rule.scope}
          />
          <span
            className="jds-title-xs"
            style={{ color: 'var(--fg-brand-strong)' }}
          >
            {formatRuleValue(rule)}
          </span>
          <span className="text-muted">
            {formatCycleRange(rule.fromCycle, rule.toCycle)}
          </span>
          {(rule.planName || rule.addonName) && (
            <span className="text-muted">
              · {rule.planName || rule.addonName}
            </span>
          )}
        </div>
      ))}
    </div>
  );
}
